<div class="flex h-full w-full items-center justify-center">
  <div
    class="mx-auto h-[30rem] w-[min(95vw,40rem)] rounded-2xl border border-gray-200 p-8 text-center shadow"
    *transloco="let t"
  >
    <div>
      <div class="mb-4 flex justify-end">
        <button
          iButton
          variant="secondary"
          size="sm"
          [loading]="isReloadingStatus()"
          [iTooltip]="t('dsp-advertiser-request-status-page.reload_status_tooltip')"
          (click)="reloadStatus()"
        >
          @if (!isReloadingStatus()) {
            <IIcon name="refresh" />
          }
          {{ t("dsp-advertiser-request-status-page.reload_status") }}
        </button>
      </div>
      <IBadge [label]="t(statusBadgeLabel()) | uppercase" size="sm" variant="soft" [color]="statusBadgeColor()" />
    </div>
    @if (isCompleted()) {
      <div class="mt-4 flex flex-col items-center gap-4">
        @if (isPartiallyCompleted()) {
          <IAlert type="warning">
            {{ t("dsp-advertiser-request-status-page.page_description_partially_completed") }}
          </IAlert>
          @if (dspAdvertiserRequest().rejectionReason) {
            <div class="w-full text-left">
              <IAlert type="warning" [title]="t('dsp-advertiser-request-status-page.partially_completed_reason_title')">
                {{ dspAdvertiserRequest().rejectionReason! }}
              </IAlert>
            </div>
          }
        } @else {
          <IAlert type="success">
            {{ t("dsp-advertiser-request-status-page.page_description_completed") }}
          </IAlert>
        }
      </div>
    } @else if (isRejected()) {
      @if (dspAdvertiserRequest().rejectionReason) {
        <div class="my-4 text-left">
          <IAlert type="error" [title]="t('dsp-advertiser-request-status-page.rejection_reason_title')">
            {{ dspAdvertiserRequest().rejectionReason! }}
          </IAlert>
        </div>
      }

      <a iButton variant="secondary" size="sm" routerLink="/dashboard/advertiser-creation-request" class="mt-4">{{
        t("dsp-advertiser-request-status-page.resubmit_request")
      }}</a>
    } @else if (needsFormCorrection()) {
      <div class="mt-4 flex flex-col items-center gap-4">
        <div>
          {{ t(formCorrectionHint()) }}
        </div>
        @if (dspAdvertiserRequest().rejectionReason) {
          <div class="w-full text-left">
            <IAlert type="warning" [title]="t('dsp-advertiser-request-status-page.form_correction_reason_title')">
              {{ dspAdvertiserRequest().rejectionReason! }}
            </IAlert>
          </div>
        }
        <a iButton variant="secondary" size="sm" routerLink="/dashboard/advertiser-creation-request">{{
          t("dsp-advertiser-request-status-page.correct_and_resubmit_request")
        }}</a>
      </div>
    } @else {
      <div class="mt-2 text-sm text-gray-500">
        <p>
          {{
            t("dsp-advertiser-request-status-page.page_description", {
              createTime: dspAdvertiserRequest().createTime | date: "short",
            })
          }}
        </p>
        @if (canUpdateRequest()) {
          <p>{{ t("dsp-advertiser-request-status-page.edit_request_hint") }}</p>
        } @else {
          <p>{{ t("dsp-advertiser-request-status-page.creation_in_progress_hint") }}</p>
        }
      </div>

      @if (
        dspAdvertiserRequest().status === DspAdvertiserRequestStatus.INCOMPLETE &&
        dspAdvertiserRequest().rejectionReason
      ) {
        <div class="my-4 text-left">
          <IAlert type="warning" [title]="t('dsp-advertiser-request-status-page.incomplete_reason_title')">
            {{ dspAdvertiserRequest().rejectionReason! }}
          </IAlert>
        </div>
      }

      @if (canUpdateRequest()) {
        <a iButton variant="secondary" size="sm" routerLink="/dashboard/advertiser-creation-request" class="mt-4">{{
          t("dsp-advertiser-request-page.update_request")
        }}</a>
      }
    }
  </div>
</div>
